module.exports = __webpack_public_path__ + "img/2.fe5d4983.png";